import { CustomerType } from "@origin-digital/platform-enums";
import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const internetHealthCheck: IMcAppType = {
  name: "internetHealthCheck",
  path: "/my/internet/health-check",
  description: "Internet Health Check",
  parameters: {
    properties: {},
  },
  navFlow: NavFlow.FOCUS,
  title: "Service health check",
  parent: Tab.DASHBOARD, // Changed from Tab.USAGE, Temporary workaround due to navigation issues on Mobile with FOCUS flow
  conditions: {
    intent: "internetHealthCheck",
    customerType: CustomerType.kraken,
  },
};
